<template>
  <v-container grid-list-xl>
    <v-alert :value="true" color="info" icon="info" v-if="showAlert2">
      <p v-html="$t('message.cuotas.periodo.alerta2')"></p>
    </v-alert>
    <v-alert :value="true" color="error" icon="warning" v-if="showAlert">
      <p v-html="$t('message.cuotas.periodo.alerta')"></p>
    </v-alert>
    <v-form ref="form" lazy-validation>
      <v-layout wrap>
        <v-flex xs12 sm6 md2>
          <DatePicker
            id="periodoConsumoPeriodo"
            v-model="form.periodoConsumo"
            placeholder="dd/mm/yyyy"
            :pickerOptions="allowedDays"
            :label="$t('message.cuotas.periodo.periodo')"
            :rules="rules.periodo"
            :error-messages="periodoErrorMessage"
          ></DatePicker>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <Numeric
            id="preciofacturacionPeriodo"
            v-model="form.facturacion"
            @input.native="changeBaseImponible(form)"
            currency="€"
            :label="$tc('message.cuotas.periodo.facturacion', 1)"
          ></Numeric>
        </v-flex>
        <v-flex xs12 sm6 md3 v-if="kwhVisible">
          <Numeric
            id="nukwhfacPeriodo"
            v-model="form.nukwhfac"
            :precision="0"
            currency="kwh"
            :label="$t('message.cuotas.periodo.nukwhfac')"
          ></Numeric>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <Numeric
            id="tipoPeriodo"
            v-model="form.tipo"
            currency="%"
            :label="$tc('message.cuotas.periodo.tipo', 1)"
            :precision="precisionTipo"
            readonly
          ></Numeric>
        </v-flex>
        <v-flex>
          <Numeric
            id="cuotaTributariaPeriodo"
            :label="$tc('message.cuotas.periodo.cuotaTributaria', 1)"
            v-model="form.cuotaTributaria"
            currency="€"
            readonly
          ></Numeric>
        </v-flex>
      </v-layout>
      <v-layout align-center justify-end row fill-height>
        <Boton id="btnCancelar" tipo="warning" :onclick="onCancel">{{
          $t('message.comun.cancelar')
        }}</Boton>
        <Boton id="btnGuardar" tipo="warning" :onclick="onSubmit">{{
          $t('message.comun.guardar')
        }}</Boton>
      </v-layout>
    </v-form>
  </v-container>
</template>
<script>
import { getVigenciaBaseCotizacionEmpresa } from '@/api/empresas';
import { Numeric, DatePicker, Boton } from '@/components';
import { mapActions } from 'vuex';
import logger from '@/utils/logger';
import moment from 'moment';
export default {
  name: 'periodoGasCuota',
  props: {
    model: {
      type: Object,
      required: true
    },
    mesFacturacion: {
      type: Date,
      required: true
    },
    kwhVisible: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      required: true,
      validator(value) {
        return value === 'new' || value === 'modify';
      }
    }
  },
  components: {
    Numeric,
    DatePicker,
    Boton
  },
  data() {
    return {
      form: {
        id: '',
        idCuota: 0,
        idBaseCo: 0,
        periodoConsumo: null,
        facturacion: 0,
        nukwhfac: 0,
        baseImponible: 0,
        tipo: 0,
        cuotaTributaria: 0
      },
      rules: {
        periodo: [() => this.periodoConsumoChangeHandler()]
      },
      periodoErrorMessage: [],
      precisionTipo: 3,
      showAlert: false,
      showAlert2: false
    };
  },
  created() {
    Object.assign(this.form, this.model);
  },
  methods: {
    ...mapActions(['setLoading']),
    allowedDays(val) {
      return (
        moment(val).toDate() <=
        moment(this.mesFacturacion)
          .endOf('month')
          .toDate()
      );
    },
    onSubmit() {
      if (this.periodoErrorMessage.length == 0) {
        this.$emit('modify', this.form);
      }
    },
    onCancel() {
      this.form = {};
      this.$emit('cancel');
    },
    changeBaseImponible(periodo) {
      if (isNaN(periodo.facturacion) || isNaN(periodo.tipo)) {
        periodo.cuotaTributaria = 0;
      } else {
        let tipo = periodo.tipo || 100;
        periodo.cuotaTributaria = Math.round10((periodo.facturacion * tipo) / 100, -2);
      }
      periodo.baseImponible = periodo.facturacion;
    },
    periodoConsumoChangeHandler() {
      this.form.tipo = 0;
      // Campo obligatorio
      if (this.form.periodoConsumo == null || this.form.periodoConsumo === '') {
        this.periodoErrorMessage = ['campo obligatorio'];
        return true;
      }
      // Validamos la vigencia de la fecha
      let payload = {
        id: this.form.id,
        idEmpresa: this.$store.getters.empresaSelected.idempres,
        idCuota: this.form.idCuota,
        idBaseCotizacion: this.form.idBaseCo,
        fechaConsumo: moment(this.form.periodoConsumo).valueOf()
      };
      this.setLoading(true);
      var self = this;

      getVigenciaBaseCotizacionEmpresa(payload).then(
        response => {
          self.form.tipo = response.data.nuporcen;
          self.periodoErrorMessage = [];
          self.changeBaseImponible(self.form);
          self.setLoading(false);
          // Si es marzo mostramos alerta
          if (moment(self.form.periodoConsumo).format('MM-YYYY') === '03-2020') {
            self.showAlert = true;
          } else {
            self.showAlert = false;
          }
          if (
            response.data.idcuota == 110 &&
            (moment(self.form.periodoConsumo).format('MM-YYYY') === '01-2021' ||
              moment(self.form.periodoConsumo).format('MM-YYYY') === '02-2021')
          ) {
            self.showAlert2 = true;
          } else {
            self.showAlert2 = false;
          }
        },
        error => {
          if (error.response && error.response.status === 404) {
            // Fecha no vigente
            this.periodoErrorMessage = [error.response.data.detail];
          } else {
            logger.print(error);
            this.periodoErrorMessage = ['No se ha podido verificar la validez de la fecha'];
          }
          this.setLoading(false);
        }
      );

      return true;
    }
  }
};
</script>
